import { CoreState } from '../store';

export const CORE_STATE_KEY = 'core';

export interface CorePartialStoreState {
    [CORE_STATE_KEY]: CoreState;
}